import { Button, Modal } from "antd";
import { useIntl } from "react-intl";
import type { ConductTransformed } from "~pages/Conducts/types/conductTransformed.ts";

type Props = {
  conduct: ConductTransformed;
  onDelete: (conductId: string) => void;
};

const DeleteConductAction = ({ conduct, onDelete }: Props) => {
  const { formatMessage } = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  const handleClick = () => {
    modal.confirm({
      title: formatMessage({ id: "conduct.delete" }),
      content: formatMessage({ id: "conduct.delete.confirm" }),
      okText: formatMessage({ id: "delete" }),
      okButtonProps: { loading: false },
      onOk: () => onDelete(conduct.conductId),
    });
  };

  return (
    <>
      {contextHolder}
      <Button onClick={handleClick} type={"text"} size={"small"} icon={<i className="fas fa-trash-can mr-2" />} />
    </>
  );
};
export default DeleteConductAction;
